export namespace FlightZoneCapabilitiesActions {
    export class GetCapabilities {
        public static readonly type = "[Flight Zone Capabilities] Get flight zone capabilities data";
    }
}
